import { rd } from '@passionware/monads';
import type { FeatureService } from 'v5/services/front/FeatureService/FeatureService';
import type { AppScopeService } from 'v5/services/internal/AppScopeService/AppScopeService';

/**
 * When `true`, invalid rows use the advanced UI (banner, manual “Display anyway”).
 * When `false`, the simple UI (auto-unsafe cells + corner warning icon).
 *
 * Driven by `low-level-validation`.
 */
export function useAdvancedValidationRowUi(
  featureService: FeatureService,
  appScopeService: AppScopeService
): boolean {
  const feature = featureService.useFeature(
    appScopeService.useResolvedScopeIdentity(),
    'low-level-validation'
  );
  return rd.getOrElse(feature, false) === true;
}
